import { PropsWithChildren } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@flintmint/web-shared/components/button';
import { getAuthUser } from '@flintmint/web-shared/hooks/use-auth-user';
import { appRoutes } from '@/constants';

import { Logo } from './logo';
import { NavLink } from './nav-link';
import styles from './layout.module.scss';

export const Layout = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();
  const { email } = getAuthUser();

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <Link to={appRoutes.home} className={styles.brand}>
          <span className={styles.logo}>
            <Logo />
          </span>
          <h1 className={styles.title}>DocuMint Admin</h1>
        </Link>
        <nav className={styles.nav}>
          <NavLink to={appRoutes.flows}>Flows</NavLink>
          <NavLink to={appRoutes.flowModules}>Flow Modules</NavLink>
          <NavLink to={appRoutes.users}>Users</NavLink>
          <NavLink to={appRoutes.accessList}>Access List</NavLink>
          <NavLink to={appRoutes.aiUsagePricing}>AI Usage & Pricing</NavLink>
          <NavLink to={appRoutes.settings}>Settings</NavLink>
        </nav>
        <div className={styles.account}>
          {email && <span className={styles.email}>{email}</span>}
          <Button
            appearance="clear"
            color="grey"
            size="small"
            data-testid="logout-btn"
            onClick={() => navigate(appRoutes.logout)}
          >
            Logout
          </Button>
        </div>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
};
